const NS = 'MmfsFilterBoxWidget';
const CLS = 'mmfsFilterBoxWidget';

export class MmfsFilterBoxWidget {
	// changedCB - on changed callback that will be called everytime the checkbox's changed
	constructor(element, changedCB) {
		this.element = element;
		this.$element = $(element);
		this.$clearBtn = $(element).find(`.${CLS}-clearBtn`);
		this.$checkboxes = $(element).find(`input[type="checkbox"]`);
		this.changedCB = changedCB;

		this.handleCheckbox();
	}

	handleCheckbox() {
		this.$checkboxes.on('change', () => {
			if(this.changedCB) {
				this.changedCB(this.getValues());
			}
		});
	}

	getValues() {
		let cbVal = [];
		this.$element.find(`input[type="checkbox"]:checked`).each((i, obj) => {
			cbVal.push($(obj).val());
		});

		return {
			name: this.$element.data('filter-key'),
			value: cbVal
		};
	}
}
